import environment from "flow/configuration/environment";

// https://www.tiny.cloud/docs/tinymce/latest/ui-localization/#language
export function getTinyCulture(): string {
    const uiCulture = environment.getUiCulture();
    const cultureLow = uiCulture.toLowerCase();

    if (cultureLow.startsWith("fi-")) {
        return "fi";
    }

    if (cultureLow.startsWith("sv-") || cultureLow === "sv-fi") {
        return "sv_SE";
    }

    if (cultureLow.startsWith("nb-")) {
        return "nb_NO";
    }

    return "en";
}
